export const apiOptions = {
  apiRoot: ((window as any).REACT_NEW_API_ROOT as string) || (process.env.REACT_APP_NEW_API_ROOT as string),
  appDomain: ((window as any).REACT_APP_DOMAIN as string) || (process.env.REACT_APP_APP_DOMAIN as string),
  messageBrokerDomain: ((window as any).MESSAGE_BROKER_DOMAIN as string) || (process.env.REACT_APP_MESSAGE_BROKER_DOMAIN as string),
  messageBrokerWebSocket: ((window as any).MESSAGE_BROKER_WEB_SOCKET as string) || (process.env.REACT_APP_MESSAGE_BROKER_WEB_SOCKET as string),
  appAssetsRootPath:
    process.env.NODE_ENV === 'development'
      ? ''
      : ((window as any).REACT_NEW_ASSETS_ROOT_PATH as string) || (process.env.REACT_APP_NEW_ASSETS_ROOT_PATH as string),
  pipelinesRouterBaseName: process.env.PIPELINES_ROUTER_BASE_NAME as string,
};
